import { AnalyticsV2Event, TelemetryEvent, TelemetryEventType } from './types';

export const isAnalyticsV2Event = (event: TelemetryEvent): event is AnalyticsV2Event =>
  event.type === TelemetryEventType.AnalyticsV2;
